import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Element } from '../element';
import * as styles from './badge.styles';

/** @type {typeof import(".").Badge} */
const Badge = forwardRef(({ className, children, isInteractive, active, ...props }, ref) => {
  return (
    <Element
      ref={ref}
      isInteractive
      className={clsx(styles.badge, className, {
        [styles.variants.active]: active,
        [styles.variants.interactive]: isInteractive,
      })}
      {...props}
    >
      {children}
    </Element>
  );
});

if (process.env.NODE_ENV !== 'production') {
  Badge.displayName = 'Badge';
}

export default Badge;
